import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useIsMobile from '../hooks/useIsMobile';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: '#f9fafb', padding: isMobile ? '1rem 0.75rem' : '3rem 1rem',
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, overflow: 'auto'
    }}>
      <div style={{
        maxWidth: '28rem', width: '100%', backgroundColor: 'white',
        borderRadius: '0.5rem', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)',
        padding: isMobile ? '1.5rem 1rem' : '2rem'
      }}>
        <div style={{ textAlign: 'center', marginBottom: isMobile ? '1.5rem' : '2rem' }}>
          <img src="/logo.png" alt="EnvíaTuPaquete.mx"
            style={{ margin: '0 auto', height: isMobile ? '8rem' : '15rem', marginBottom: '0.5rem' }} />
          <h2 style={{ fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 'bold', color: '#111827' }}>
            Iniciar Sesión
          </h2>
          <p style={{ marginTop: '0.5rem', color: '#6b7280', fontSize: isMobile ? '0.875rem' : '1rem' }}>
            Accede a tu cuenta
          </p>
        </div>

        {error && (
          <div style={{
            backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b',
            padding: '0.75rem 1rem', borderRadius: '0.375rem', marginBottom: '1rem', fontSize: '0.875rem'
          }}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label htmlFor="email" style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>Email</label>
            <input id="email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
              placeholder="tu@email.com" />
          </div>
          <div>
            <label htmlFor="password" style={{ display: 'block', fontSize: '0.875rem', fontWeight: '500', color: '#374151', marginBottom: '0.25rem' }}>Contraseña</label>
            <input id="password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%', padding: '0.625rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
              placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '0.75rem 1rem', backgroundColor: loading ? '#fed7aa' : '#ff8c00',
            color: 'white', fontWeight: '600', borderRadius: '0.375rem', border: 'none',
            cursor: loading ? 'not-allowed' : 'pointer', fontSize: '1rem', transition: 'background-color 0.2s'
          }}>{loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}</button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <Link to="/forgot-password" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#6b7280', textDecoration: 'none' }}>
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            ¿No tienes cuenta?{' '}
            <Link to="/registro" style={{ fontWeight: '500', color: '#ff8c00', textDecoration: 'none' }}>Regístrate aquí</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
